import { render, staticRenderFns } from "./commissionItem.vue?vue&type=template&id=1e982f15&scoped=true&"
import script from "./commissionItem.vue?vue&type=script&lang=js&"
export * from "./commissionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e982f15",
  null
  
)

export default component.exports